<template>
    <div class="container-fluid">
        <div class="horizontal-nav mb-1">
            <nav aria-label="...">
                <ul class="pagination">
                    <li class="page-item" v-for="phase in this.phases" :key="phase.Id">
                        <div class="dropdown" v-if="phase.HasFrameworkConditions" >
                            <a
                                class="page-link  dropdown-toggle"
                                :class="(isActivePhase(phase))?'active':''"
                                href="#"
                                role="button"
                                :id="getIdForDropdown(phase.Name)"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                > <span class="title-phase">{{ phase.Name }}</span>
                            </a>
                            <div class="dropdown-menu" :aria-labelledby="getIdForDropdown(phase.Name)">
                                <router-link :to="'/result/phase/' +replaceSpaceAndMakeLowerCase(phase.Name)">
                                    <a class="dropdown-item">Phase</a>
                                </router-link>
                                <router-link :to="'/result/phase/' +replaceSpaceAndMakeLowerCase(phase.Name) +'-framework-condition'">
                                    <a class="dropdown-item" href="#">Rahmenbedingungen</a>
                                </router-link>
                            </div>
                        </div>
                        <div v-else class="" type="button">
                            <router-link :to="'/result/phase/' +replaceSpaceAndMakeLowerCase(phase.Name)">
                                <a class="page-link" href="#" :class="(isActivePhase(phase))?'active':''">{{ phase.Name }}</a>
                            </router-link>
                        </div>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    name: "HorizontalNav",
    props: ["phases", "activPhase"],
    methods: {
        replaceSpaceAndMakeLowerCase(name) {
            return name.replaceAll('-', '').replace(/\s/g, '-').toLowerCase();
        },
        getIdForDropdown(name) {
            return "dropdown-" + this.replaceSpaceAndMakeLowerCase(name);
        },
        isActivePhase(phase){
            if(phase.Name === this.activPhase) return true;
            else return false;
        }
    }

};
</script>

<style scoped>
    .dropdown-toggle {
        white-space: normal;
    }
    .dropdown-toggle::after {
        display: none;
    }

    .page-link{
        min-height: 54px;
    }
    a{
        color: #236A66;
    }

</style>